// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-header[data-v-6b527060]{box-sizing:border-box;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
